import { render, staticRenderFns } from "./CustomersWizardStatusView.vue?vue&type=template&id=19c401ef"
import script from "./CustomersWizardStatusView.vue?vue&type=script&lang=js"
export * from "./CustomersWizardStatusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports